import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthGuard } from '@/components/auth/AuthGuard';
import { AdminGuard, TrainerGuard } from '@/components/auth/RoleGuard';
import { Loader2 } from 'lucide-react';

const Layout = lazy(() => import('./Layout.jsx'));
const Dashboard = lazy(() => import('./Dashboard'));
const Training = lazy(() => import('./Training'));
const Employees = lazy(() => import('./Employees'));
const PinLoginPage = lazy(() => import('./PinLoginPage'));
const Admin = lazy(() => import('./Admin'));
const Reports = lazy(() => import('./Reports'));
const ManageTraining = lazy(() => import('./ManageTraining'));
const ModulesManagement = lazy(() => import('./ModulesManagement'));
const GroupsManagement = lazy(() => import('./GroupsManagement'));
const DetailedReports = lazy(() => import('./DetailedReports'));

function LoadingFallback() {
  return (
    <div className="min-h-screen bg-[#FBF9F3] flex items-center justify-center">
      <div className="brand-card text-center py-12">
        <Loader2 className="w-12 h-12 text-[#C6A136] animate-spin mx-auto mb-4" />
        <h3 className="text-xl font-semibold text-[#4B2E14] mb-2">
          Cargando...
        </h3>
      </div>
    </div>
  );
}

function PagesContent() {
    return (
        <Suspense fallback={<LoadingFallback />}>
            <Routes>
                <Route path="/login" element={
                    <AuthGuard requireAuth={false}>
                        <PinLoginPage />
                    </AuthGuard>
                } />

                <Route path="/" element={
                    <AuthGuard>
                        <Layout>
                            <Dashboard />
                        </Layout>
                    </AuthGuard>
                } />

                <Route path="/dashboard" element={
                    <AuthGuard>
                        <Layout>
                            <Dashboard />
                        </Layout>
                    </AuthGuard>
                } />

                <Route path="/training" element={
                    <AuthGuard>
                        <Layout>
                            <Training />
                        </Layout>
                    </AuthGuard>
                } />

                <Route path="/employees" element={
                    <AuthGuard>
                        <Layout>
                            <AdminGuard>
                                <Employees />
                            </AdminGuard>
                        </Layout>
                    </AuthGuard>
                } />

                <Route path="/admin" element={
                    <AuthGuard>
                        <Layout>
                            <AdminGuard>
                                <Admin />
                            </AdminGuard>
                        </Layout>
                    </AuthGuard>
                } />

                <Route path="/reports" element={
                    <AuthGuard>
                        <Layout>
                            <AdminGuard>
                                <Reports />
                            </AdminGuard>
                        </Layout>
                    </AuthGuard>
                } />

                <Route path="/manage-training" element={
                    <AuthGuard>
                        <Layout>
                            <TrainerGuard>
                                <ManageTraining />
                            </TrainerGuard>
                        </Layout>
                    </AuthGuard>
                } />

                <Route path="/modules" element={
                    <AuthGuard>
                        <Layout>
                            <TrainerGuard>
                                <ModulesManagement />
                            </TrainerGuard>
                        </Layout>
                    </AuthGuard>
                } />

                <Route path="/groups" element={
                    <AuthGuard>
                        <Layout>
                            <AdminGuard>
                                <GroupsManagement />
                            </AdminGuard>
                        </Layout>
                    </AuthGuard>
                } />

                <Route path="/detailed-reports" element={
                    <AuthGuard>
                        <Layout>
                            <AdminGuard>
                                <DetailedReports />
                            </AdminGuard>
                        </Layout>
                    </AuthGuard>
                } />
            </Routes>
        </Suspense>
    );
}

export default function Pages() {
    return (
        <Router>
            <PagesContent />
        </Router>
    );
}
